import { useEffect, useState } from "react";
import { useAIRoleBuilderTasksContext } from "hooks";
import {
  AI_ROLE_BUILDER_TASK_DISPLAY_STATE as TASK_DISPLAY_STATE,
  getRoleBuilderTaskDisplayState,
} from "constants/index";

/**
 * useRoleBuilderTask
 *
 * The AI role builder request behind the builder's first step, read live from the requests
 * queue so the builder can wait on it without closing.
 *
 * @param {Object}  task  A request to review, when resuming one
 */
export default function useRoleBuilderTask({ task }) {
  const { tasks, submitTask, discardTask } = useAIRoleBuilderTasksContext();
  const [taskId, setTaskId] = useState(task?.id);
  const reviewTask = tasks.find(({ id }) => id === taskId) || task;
  const isTaskReady = getRoleBuilderTaskDisplayState(reviewTask) === TASK_DISPLAY_STATE.READY;
  // The description editor only reads its value on mount, so the review fields wait a render for the generated values.
  const [isReviewReady, setIsReviewReady] = useState(isTaskReady);

  useEffect(() => {
    if (isTaskReady) setIsReviewReady(true);
  }, [isTaskReady]);

  const handleJobSubmitted = (result) => {
    submitTask(result);
    setTaskId(result?.submitAiRoleBuilderJob?.task?.id);
  };

  const discardReviewedTask = (missionRoleId) => {
    if (taskId) discardTask(taskId, { missionRoleId });
  };

  return { taskId, reviewTask, isTaskReady, isReviewReady, handleJobSubmitted, discardReviewedTask };
}
